import {
    LOAD_TENDER_TYPE_MAPPINGS_SUCCESS,
    UPDATE_TENDER_TYPE_MAPPINGS_SUCCESS,
    IMPORT_POS_TENDER_TYPES_SUCCESS,
    CLEAR_TENDER_TYPE_MAPPINGS }from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_TENDER_TYPE_MAPPINGS_SUCCESS:
            return action.payload;
        case UPDATE_TENDER_TYPE_MAPPINGS_SUCCESS:
            return action.payload;
        case IMPORT_POS_TENDER_TYPES_SUCCESS:
            return action.payload;
        case CLEAR_TENDER_TYPE_MAPPINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/pos/TenderTypeMappingReducer.js